import idx from 'idx';

import type { CcpEntitlementQuery } from './__types__/CcpEntitlementQuery';

export const getCcpEntitlementFromQuery = (
	data: CcpEntitlementQuery | undefined,
): string | undefined => {
	return data && (idx(data, (_) => _.siteConfiguration.ccpEntitlementId) || undefined);
};
